import React from 'react';
import { Modal } from 'react-bootstrap';


const EmailWaitingListModal = ({ show, onHide }) => {
    const iFrameSrc = "https://tally.so/embed/3NAOPN?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1";

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Join our waiting list</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <iframe
                    src={iFrameSrc}
                    width="100%"
                    height="560px" // Adjust the size as necessary
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    allowfullscreen
                    title="Embedded content"
                >
                    Sorry, your browser doesn't support embedded videos.
                </iframe>
            </Modal.Body>
        </Modal>
    );
};

export default EmailWaitingListModal;